import { Injectable } from '@angular/core';
import { environment } from '@environment';

const noop = () => {};
const logPrefix = '%cCRM:';
const logStyle = 'background: #3075F4; color: #fff; border-radius:2px';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private static hasConsole(): boolean {
    return !!window.console;
  }

  get info() {
    if (!LoggerService.hasConsole() || environment.production) {
      return noop;
    }

    return window.console.info.bind(window.console, logPrefix, logStyle);
  }

  get warn() {
    if (!LoggerService.hasConsole() || environment.production) {
      return noop;
    }

    return window.console.warn.bind(window.console, logPrefix, logStyle);
  }

  get error() {
    if (!LoggerService.hasConsole() || environment.production) {
      return noop;
    }

    return window.console.error.bind(window.console, logPrefix, logStyle);
  }
}
